






















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        content: Object
    },

    computed: {
        image() {
            return this.content.image && 'section-block--image' || '';
        },
        size() {
            return this.content.size && 'block--' + this.content.size || '';
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Section extends Vue {}

